import { createFileRoute, redirect } from '@tanstack/react-router'

import keycloak from '@/core/keycloak'

export const Route = createFileRoute('/skills-assessment')({
  beforeLoad: () => {
    if (!keycloak.authenticated) {
      throw redirect({ href: keycloak.createLoginUrl() })
    }
  },
})
